import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
const stateClasses = {
    GREEN: 'bg-[rgba(31,110,92,0.12)] text-ax-deadline-green border-[rgba(31,110,92,0.40)]',
    YELLOW: 'bg-[rgba(201,136,28,0.12)] text-ax-deadline-yellow border-[rgba(201,136,28,0.40)]',
    ORANGE: 'bg-[rgba(217,119,6,0.14)] text-ax-deadline-orange border-[rgba(217,119,6,0.45)]',
    RED: 'bg-[rgba(255,92,92,0.14)] text-ax-deadline-red border-[rgba(255,92,92,0.45)] animate-ax-pulse-critical',
    MISSED: 'bg-[rgba(122,10,10,0.30)] text-ax-ivory border-ax-deadline-missed font-semibold animate-ax-pulse-critical',
};
export function DeadlinePill({ state, label, title }) {
    return (_jsxs("span", { title: title, className: cn('inline-flex items-center gap-1.5 px-2 py-0.5 rounded-ax-pill border', 'font-mono text-[11px] tracking-wider uppercase', stateClasses[state]), children: [_jsx("span", { "aria-hidden": "true", className: "inline-block h-1.5 w-1.5 rounded-full bg-current" }), label] }));
}
//# sourceMappingURL=DeadlinePill.js.map